<!--查看详情-->
<template>
  <el-dialog title="详情" :visible="true" width="23%" :before-close="handleClose">
    <el-form ref="form" :model="form" label-width="120px">
      <div class="title">
        <p>经销商信息</p>
      </div>
      <el-form-item label="经销商编号:">
        <span>{{prop.dealer_sn}}</span>
      </el-form-item>
      <el-form-item label="经销商名称:">
        <span>{{prop.dealer_name}}</span>
      </el-form-item>
      <el-form-item label="经销商级别:">
        <span>{{prop.dealer_level_name}}</span>
      </el-form-item>
      <el-form-item label="上级经销商:" v-if="prop.is_parent==2">
        <span>{{prop.superior_dealer_name}}</span>
      </el-form-item>
      <el-form-item label="账户余额:">
        <span style="color: red">{{prop.account_balance}}</span>
      </el-form-item>
      <div class="title">
        <p>返利详情</p>
      </div>
      <el-form-item label="订单号:">
        <span style="color: blue;cursor: pointer">{{prop.settlement_order_sn}}</span>
      </el-form-item>
      <el-form-item label="返利金额:" v-if="prop.settlement_type==1">
        <span>{{prop.settlement_money}}</span>
      </el-form-item>
      <el-form-item label="结算金额:" v-if="prop.settlement_type==2">
        <span>{{prop.settlement_money}}</span>
      </el-form-item>
      <el-form-item label="返利时间:">
        <span>{{prop.settlement_time}}</span>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: "detail",
  data() {
    return {
      form: {}
    };
  },
  props: {
    prop: Object
  },
  methods: {
    handleClose() {
      this.$emit("handleClose");
    }
  },
  created() {
    console.log(this.prop);
  }
};
</script>

<style lang="scss" scoped>
.title {
  border-bottom: 1px solid #ccc;
  font-size: 16px;
  color: black;
  padding: 10px;
}
</style>